export class MenuItem {
  id: string;
  label: string;
  title?: string;
  link: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  isBottom?: boolean = false;
  hasChildren?: boolean = false;

  constructor({
    id,
    label,
    title = undefined,
    link,
    icon,
    activeIcon = undefined,
    isBottom = false,
    hasChildren = false,
  }: MenuItem) {
    this.id = id;
    this.label = label;
    this.title = title;
    this.link = link;
    this.icon = icon;
    this.activeIcon = activeIcon;
    this.isBottom = isBottom;
    this.hasChildren = hasChildren;
  }
}
